export interface RetryOptions {
  maxRetries: number;
  retryDelay?: number;
}

export async function withRetry<T>(operation: () => Promise<T>, options: RetryOptions): Promise<T> {
  const { maxRetries, retryDelay = 1000 } = options;
  let retryCount = 0;

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  while (retryCount < maxRetries) {
    try {
      return await operation();
    } catch (e) {
      retryCount++;

      if (retryCount >= maxRetries) {
        throw e;
      }

      await sleep(retryDelay);
    }
  }

  throw new Error('Unexpected end of retry loop');
}
